/* istanbul ignore file */
import Vue from "vue";
import StoreStaticMap_Google from "./StoreStaticMap_Google";

const vueEl = "[data-vue-app='static-map']";
const vueView = "[data-vue-view]";

document.ready.then(() => {
  const isVueView = document.querySelectorAll(vueView).length > 0;
  if (document.querySelector(vueEl) && !isVueView) {
    new Vue({
      el: vueEl,
      components: {
        "google-map-static": StoreStaticMap_Google,
      },
    });
  }
});
